'use strict';

angular.module('TurneroApp').component('coSelectCentroAtencion', {
    bindings: {
        open: '<',
        centroAtencionSeleccionado: '<',
        centroAtencionCallback: '&',
        onClose: '&',
    },
    controller: [
		 '$mdDialog',
		 'centrosAtencionService',
		 'utilsService',
        function ($mdDialog, centrosAtencionService, utilsService) {
		     var ctrl = this;

		     //ctrl.$onChanges = function () {
		     //	ctrl.ultimoCentroSeleccionado = ctrl.centroAtencionSeleccionado
		     //}

		     ctrl.cambiarCentroDeAtencion = function (centro) {
		         ctrl.centroAtencionSeleccionado = centro;
		         if (ctrl.centroAtencionSeleccionado) {
		             //$.hubConnection().disconnected()
		             //signalrService.connect();
		             ctrl.centroAtencionCallback({
		                 centroAtencionSeleccionado: ctrl.centroAtencionSeleccionado
		             });
		             $mdDialog.hide();
		         };
		     };

		     ctrl.clearSearchTerm = function () {
		         ctrl.searchTerm = '';
		     };

		     ctrl.close = function () {
		         ctrl.onClose();
		         $mdDialog.cancel();
		     };

		     ctrl.$onChanges = function (changesObj) {
		         ctrl.promise = centrosAtencionService.getCombo(function (centrosAtencion) {
		             ctrl.centrosAtencion = centrosAtencion;

		             //var centroselect = sessionStorage.getItem('ngStorage-TurneroApp_CentroSeleccionado');
		             var centroselect = ctrl.centroAtencionSeleccionado;

		             if (centroselect === undefined || centroselect === null || Object.keys(centroselect).length === 0) {
		                 var cant = centrosAtencion.length;

		                 if (cant === 1) {
		                     ctrl.cambiarCentroDeAtencion(centrosAtencion[0]);
		                 }
		             }

		             if (ctrl.open) {
		                 $mdDialog.show({
		                     template: require('./selectCentroAtencion.html'),
		                     controllerAs: '$ctrl',
		                     controller: function () {
		                         return ctrl;
		                     },
		                     clickOutsideToClose: true,
		                     onRemoving: ctrl.close
		                 });
		             }
		         });
		     };

		     ctrl.querySearch = function (query) {
		         var results = query ? ctrl.centrosAtencion.filter(createFilterFor(utilsService.removeAccents(query))) : ctrl.centrosAtencion,
                      deferred;
		         if (ctrl.simulateQuery) {
		             deferred = $q.defer();
		             $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
		             return deferred.promise;
		         } else {
		             return results;
		         }
		     }
		     function createFilterFor(query) {
		         var upperQuery = angular.uppercase(query);
		         return function filterFn(centro) {
		             centro = utilsService.removeAccents(angular.lowercase(centro.text))
		             return (angular.uppercase(centro).indexOf(upperQuery) >= 0);
		         };
		     }
		 }]//,
    //template: require('./selectCentroAtencion.html')
});


// WEBPACK FOOTER //
// ./app/shared/selectCentroAtencion/selectCentroAtencion.js